/* SourceSelectBoxEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
// const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class SourceSelectBoxEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        const dropDownData = [
            {label: "CMDB", value: "CI_TO_DEVICE"},
            {label: "Gluware", value: "DEVICE_TO_CI"},
        ];
        this.input.setOptions(dropDownData);
        super._init();
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: false,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    findType(entries, valueToFind) {
        // Iterate through each entry in the input
        for (const entry of entries) {
            // Check if the current entry's value matches the value to find
            if (entry.value === valueToFind) {
                // Return the type if a match is found
                return entry.type;
            }
        }
        // Return null if the value is not found in any entry
        return null;
    }

    show() {}
    hide() {}
}

module.exports = SourceSelectBoxEditor;
